import React from 'react';
import { headingLabelText } from '../fmHostedHeading';

/**
 * Nothing to plot: one line saying so, under the title when the host has not
 * printed it. A framed empty plot would promise a figure that is not there.
 */
export const FmChartBlockNotice: React.FC<{
  title: string;
  showTitle: boolean;
  text: string;
  className?: string;
  'data-testid': string;
}> = ({ title, showTitle, text, className, 'data-testid': testId }) => (
  <section
    className={['fm-chart-block', 'fm-chart-block--unavailable', className]
      .filter(Boolean)
      .join(' ')}
    aria-label={headingLabelText(title)}
    data-state="empty"
    data-testid={testId}
  >
    {showTitle ? <p className="fm-chart-block__notice-title">{title}</p> : null}
    <output className="fm-chart-block__notice">{text}</output>
  </section>
);
